import { render } from "./LogoHeader.vue?vue&type=template&id=f9230768"
import script from "./LogoHeader.vue?vue&type=script&lang=ts"
export * from "./LogoHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script